import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { green, red } from "@mui/material/colors";
import api from "../api/axios";
import { TENANT_AUTH } from '../authMode';

const UNAVAILABLE_STATUS = {
  database: "UNKNOWN",
  connected: false,
  available: false,
};

const INITIAL_STATUS = {
  database: "UNKNOWN",
  connected: false,
  available: null,
};

export default function DatabaseStatus() {
  const [status, setStatus] = useState(INITIAL_STATUS);

  useEffect(() => {
    let mounted = true;

    const loadStatus = () => {
      const operation = TENANT_AUTH
        ? api.get('/system/database-status', { backgroundAuth: true })
        : api.get('/system/database-status');
      operation
        .then(({ data }) => {
          if (mounted) {
            setStatus({
              database: data.database,
              connected: data.connected === true,
              available: true,
            });
          }
        })
        .catch(() => {
          if (mounted) {
            setStatus(UNAVAILABLE_STATUS);
          }
        });
    };

    loadStatus();
    const timer = window.setInterval(loadStatus, 30000);

    return () => {
      mounted = false;
      window.clearInterval(timer);
    };
  }, []);

  const hasError = status.available === false
    || (status.available === true && !status.connected);
  const stateText = status.available === null
    ? "Status wird geladen"
    : status.available === false
    ? "STATUS NICHT VERFÜGBAR"
    : status.connected ? "verbunden" : "KEINE VERBINDUNG";

  return (
    <Box
      role="status"
      sx={{
        mt: 1,
        mx: 0.75,
        px: 1,
        py: 0.5,
        boxSizing: "border-box",
        fontSize: "0.625rem",
        lineHeight: 1.4,
        color: hasError ? red[900] : green[900],
        bgcolor: hasError ? red[50] : green[50],
        borderRadius: 1,
      }}
    >
      Datenbank:
      <br />
      <Box component="span" sx={{ whiteSpace: "nowrap" }}>
        {status.database} · {stateText}
      </Box>
    </Box>
  );
}
